
export const keyForCodeForSection = {
    enrolled: "enrolled",
    verify: "verify",
    watch: "watch",
    exam: "exam",
    certificate: "certificate",
    submit: "submit"
} as const

export const sectionLockStatus = {
    locked:"locked",
    unLocked:"unLocked"
} as const